<template>
  <div>
    <nuxt-link
      v-if="pdpLink"
      :to="product.url"
      class="product-main"
      @click="$emit('detail-clicked', product)"
    >
      <NarrativeProductCardImage :product="product" />
      <NarrativeProductCardTagLine
        :product="product"
        :extra-savings="extraSavings"
      />
    </nuxt-link>
    <a
      v-else
      href="#"
      class="product-main"
      @click.prevent="$emit('detail-clicked', product)"
    >
      <NarrativeProductCardImage :product="product" />
      <NarrativeProductCardTagLine
        :product="product"
        :extra-savings="extraSavings"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'NarrativeProductCardDisplay',
  components: {
    NarrativeProductCardImage: defineAsyncComponent(
      () => import('@/components/Product/Card/NarrativeProductCardImage.vue'),
    ),
    NarrativeProductCardTagLine: defineAsyncComponent(
      () => import('@/components/Product/Card/NarrativeProductCardTagLine.vue'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    extraSavings: {
      type: String,
      required: false,
      default: null,
    },
    pdpLink: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['detail-clicked'],
}
</script>
